import styles from '../styles/loader.module.scss';

export const Loader = () => {
  return (
    <div className={styles['horizontal-bar-wrap']}>
      <div className={`${styles['horizontal-bar-wrap__bar']} ${styles['bar1']}`}></div>
    </div>
  );
};
